module.exports = __webpack_public_path__ + "static/stoner-b10a07e6e9b8fb8c9d21659376d92df3.jpg";